<template>
	<div :class="`flex-grow-1 align-content-center w-100 p-2`">
		<router-link
			:to="{ name: getRoute() }"
			class="pointer h-100"
			tag="div"
		>
			<div :class="`${data.color} ${getTextColor(data.color)} contenu-button rounded d-flex w-100 h-100 align-items-center p-2`" ref="boutoncontainer">
				<icon class="iconHome ms-3 me-3" style="fill: #fff" :name="data.icon"></icon>
				<p>{{ data.label }}</p>
			</div>
		</router-link>
	</div>
</template>

<script>
export default {
	name: "MenuItem",
	props: {
		data: Object
	},
	components: {

	},
	computed: {

	},
	methods: {
		getTextColor: function (data) {
			let backgroudColor = data;
			let textColor = "white";
			if (backgroudColor === "onahau") textColor = "black";
			return textColor;
		},
		getRoute() {

			console.log("route : ", this.data.route);

			return this.data.route;
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

@import "../scss/variables"; 

p {
	margin: 0;
	text-transform: uppercase;
	font-size: 16px;
}
.home-button {
	flex: 1 1 0;
	//height: 100%;
}
.iconHome {
	width: 30px;
	height: 30px;
	margin-bottom: 5px;
}
.iconHome svg {
	color: #fff;
}
.contenu-button {
	font-weight: bold;
	margin: auto;
}
.contenu-button-disabled {
	background-color: #dddddd;
}
.black {
	color: black;
}
.white {
	color: white;
}
.blueChill {
	background-color: $blueChill;
}
.home {
	background-color: #086265;
}

.mediumAquamarine {
	background-color: $mediumAquamarine;
}
.onahau {
	background-color: $onahau;
}
.darkTurquoise {
	background-color: $darkTurquoise;
}
.deepBlue {
	background-color: $deepBlue;
}
.montana {
	background-color: $montana;
}
</style>
